/**
 * ResourceManagementPage - Standalone page for Indirect Resources Management dashboard.
 * Route: /resource-management (Resources > Indirect Resources).
 * Presence ("N viewing") is shown by the dashboard's own toolbar pill.
 */

import React from 'react';
import IndirectResourcesDashboard from './IndirectResourcesDashboard';

const ResourceManagementPage = () => (
  <div style={{ minHeight: '100%', backgroundColor: '#f5f7fa' }}>
    <IndirectResourcesDashboard />
  </div>
);

export default ResourceManagementPage;
